export default "__VITE_ASSET__RVyp2D6k__"